export enum ArticleState {
	/// <summary>
	/// Keine Fehler vorhanden. Artikel kann bestellt werden.
	/// </summary>
	OK = 0,

	/// <summary>
	/// Änderungen wurden am Artikel vorgenommen oder der Artikel
	/// kann nicht garantiert hergestellt werden.
	/// </summary>
	Warning = 1,

	/// <summary>
	/// Der Artikel hat Fehler und kann so nicht bestellt werden.
	/// </summary>
	Error = 2,

	/// <summary>
	/// Artikel ist in Überprüfung bei Blexon und kann nicht bearbeitet werden.
	/// </summary>
	Locked = 3,

	/// <summary>
	/// Artikel ist ganz neu und wurde noch nicht berechnet.
	/// </summary>
	New = 4,

	/// <summary>
	/// Artikel ist in einem CAD/CAM geöffnet.
	/// Der Artikel kann nur readonly geöffnet werden.
	/// </summary>
	Open = 5,

	Info = 6,

	/// <summary>
	/// Der Artikel wurde gelöscht, kann aber nicht mehr wirklich gelöscht werden,
	/// weil es Bestellungen gibt.
	/// </summary>
	Deleted = 9,
}
